import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Grid,
  Segment
} from 'semantic-ui-react';

import { formatDate } from '_utils';
import { sublicensePropType } from '_utils/licenses';
import { getACLicenseTypeLabel, getACLicenseStatusLabel, getACLicenseExpiresOnLabel } from '_utils/activationCodes';

import { STATUS } from '../../../server/constants';

import LineItem from '_views/lineItem';
import UserInfo from '_views/userInfo';

const ACSublicense = ({
  sublicense
}) => {

  return (
    <Segment tertiary={ sublicense.status === STATUS.NOT_ACTIVE } >
      <Grid>
        <Grid.Row columns={ 2 }>
          <Grid.Column width={ 8 } >
            <LineItem label='Type' text={ getACLicenseTypeLabel(sublicense) } />
            <LineItem label='License Pool ID' text={ sublicense.license_pool_id } />
            <LineItem label='Created On' text={ formatDate(sublicense.activated_on) } />
            <LineItem label='Status' text={ getACLicenseStatusLabel(sublicense) } />
            <LineItem label='Expires' text={ getACLicenseExpiresOnLabel(sublicense) } />
          </Grid.Column>
          <Grid.Column width={ 8 } >
            {
              sublicense.status === STATUS.NOT_ACTIVE ? (
                <div>
                  <div>
                    <b>Deactivated On:</b>
                  </div>
                  <div>
                    { formatDate(sublicense.deactivated_on) }
                  </div>
                  <div>
                    <b>Deactivated by:</b>
                  </div>
                  <UserInfo user={ sublicense.deactivated_by } />
                </div>
              ) : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

ACSublicense.propTypes = {
  sublicense: sublicensePropType.isRequired
};

const ACLicenseSublicenses = ({
  sublicenses
}) => {

  const activeSublicenses = sublicenses.filter((sl) => sl.status === STATUS.ACTIVE);
  const inactiveSublicenses = sublicenses.filter((sl) => sl.status !== STATUS.ACTIVE);

  return (
    <Fragment>
      {
        activeSublicenses.length || inactiveSublicenses.length ? (
          <Segment.Group>
            {
              activeSublicenses.map(sublic => (
                <ACSublicense key={ sublic._id } sublicense={ sublic } />
              ))
            }
            {
              inactiveSublicenses.map(sublic => (
                <ACSublicense key={ sublic._id } sublicense={ sublic }/>
              ))
            }
          </Segment.Group>
        ) : 'None'
      }
    </Fragment>
  );
};

ACLicenseSublicenses.propTypes = {
  sublicenses: PropTypes.arrayOf(sublicensePropType).isRequired
};

export default ACLicenseSublicenses;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/sublicenses.js